/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsFxNativeStyleOptions interface.
 */
export function instanceOfFxIdDomainSettingsFxNativeStyleOptions(value) {
    return true;
}
export function FxIdDomainSettingsFxNativeStyleOptionsFromJSON(json) {
    return FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'LogoUrl': json['LogoUrl'] == null ? undefined : json['LogoUrl'],
        'BackgroundImageUrl': json['BackgroundImageUrl'] == null ? undefined : json['BackgroundImageUrl'],
        'TextureOverlayUrl': json['TextureOverlayUrl'] == null ? undefined : json['TextureOverlayUrl'],
        'PaymentItemGradientStartColor': json['PaymentItemGradientStartColor'] == null ? undefined : json['PaymentItemGradientStartColor'],
        'PaymentItemGradientEndColor': json['PaymentItemGradientEndColor'] == null ? undefined : json['PaymentItemGradientEndColor'],
        'OverlayColor': json['OverlayColor'] == null ? undefined : json['OverlayColor'],
        'ProductOfferGradientColor': json['ProductOfferGradientColor'] == null ? undefined : json['ProductOfferGradientColor'],
        'TextColor': json['TextColor'] == null ? undefined : json['TextColor'],
        'InputBackgroundColor': json['InputBackgroundColor'] == null ? undefined : json['InputBackgroundColor'],
        'InputTextColor': json['InputTextColor'] == null ? undefined : json['InputTextColor'],
        'InputBorderColor': json['InputBorderColor'] == null ? undefined : json['InputBorderColor'],
        'InputErrorColor': json['InputErrorColor'] == null ? undefined : json['InputErrorColor'],
        'TextureOverlayOpacity': json['TextureOverlayOpacity'] == null ? undefined : json['TextureOverlayOpacity'],
        'PricePlacement': json['PricePlacement'] == null ? undefined : json['PricePlacement'],
    };
}
export function FxIdDomainSettingsFxNativeStyleOptionsToJSON(json) {
    return FxIdDomainSettingsFxNativeStyleOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsFxNativeStyleOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'LogoUrl': value['LogoUrl'],
        'BackgroundImageUrl': value['BackgroundImageUrl'],
        'TextureOverlayUrl': value['TextureOverlayUrl'],
        'PaymentItemGradientStartColor': value['PaymentItemGradientStartColor'],
        'PaymentItemGradientEndColor': value['PaymentItemGradientEndColor'],
        'OverlayColor': value['OverlayColor'],
        'ProductOfferGradientColor': value['ProductOfferGradientColor'],
        'TextColor': value['TextColor'],
        'InputBackgroundColor': value['InputBackgroundColor'],
        'InputTextColor': value['InputTextColor'],
        'InputBorderColor': value['InputBorderColor'],
        'InputErrorColor': value['InputErrorColor'],
        'TextureOverlayOpacity': value['TextureOverlayOpacity'],
        'PricePlacement': value['PricePlacement'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsFxNativeStyleOptions.js.map